import { featuresData } from '../../../mocks/services';

const FeaturesSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center mb-16">
          <div>
            <h2 className="font-montserrat font-bold text-5xl text-gray-900 mb-2">
              Why Choose <span className="text-orange-500">Our Services</span>
            </h2>
            <p className="text-gray-600 font-sans text-lg">
              Delivering exceptional value and results for every client
            </p>
          </div>
          <div className="hidden lg:block">
            <div className="bg-gray-900 text-white px-6 py-2 rounded-full font-sans font-semibold text-sm">
              Award Winning
            </div>
          </div>
        </div>

        <div className="overflow-x-auto pb-6">
          <div className="flex gap-6" style={{ width: 'max-content' }}>
            {featuresData.map((feature) => (
              <div
                key={feature.id}
                className="bg-gray-50 rounded-3xl p-8 hover:shadow-lg transition-all duration-300 cursor-pointer"
                style={{ width: '320px' }}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-16 h-16 flex items-center justify-center bg-orange-500/10 rounded-2xl">
                    <i className={`${feature.icon} text-3xl text-orange-500`}></i>
                  </div>
                  <div className="text-right">
                    <p className="font-montserrat font-bold text-4xl text-gray-900">
                      {feature.metric}
                    </p>
                  </div>
                </div>
                <h3 className="font-montserrat font-bold text-xl text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 font-sans text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
